// ── ParticipantPmtForm ──
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const ParticipantPmtForm = ({ initial, loanid, participantscheduledpmtid, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const returnTo = modal?.returnTo;
    const handleClose = () => {
      if (returnTo) setModal(returnTo);
      else closeModal();
    };
    const [f, set] = useFreshForm(initial||{
      loanid: loanid||null,
      participantscheduledpmtid: participantscheduledpmtid||null,
      paymentdate:"", principalamount:"", interestamount:"",
      feetype:"", feeamount:"", othertype:"", otheramount:""
    }, "ParticipantPmts");
    const feeTypeOptions = ["","Origination Fee","Amendment Fee","Annual Fee","Monthly Fee","Unused Fee","Other"];
    return <Modal title={readOnly?"View Participant Payment":initial?"Edit Participant Payment":"Add Participant Payment"} onClose={handleClose}
      onEdit={readOnly&&role.canEdit?()=>setModal({type:"participantpmt-edit",rec:initial,loanid,participantscheduledpmtid,onDone:modal.onDone}):null}>
      <ReadOnlyForm readOnly={readOnly}>
        <Field label="Payment Date"><FInput value={f.paymentdate?.slice(0,10)||""} onChange={set("paymentdate")} type="date" /></Field>
        <div />
        <Field label="Principal Amount"><FInput value={f.principalamount||""} onChange={set("principalamount")} type="number" step="0.01" /></Field>
        <Field label="Interest Amount"><FInput value={f.interestamount||""} onChange={set("interestamount")} type="number" step="0.01" /></Field>
        <Field label="Fee Type"><FSelect value={f.feetype||""} onChange={set("feetype")} options={feeTypeOptions} /></Field>
        <Field label="Fee Amount"><FInput value={f.feeamount||""} onChange={set("feeamount")} type="number" step="0.01" /></Field>
        <Field label="Other Type"><FInput value={f.othertype||""} onChange={set("othertype")} /></Field>
        <Field label="Other Amount"><FInput value={f.otheramount||""} onChange={set("otheramount")} type="number" step="0.01" /></Field>
        


      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:8 }}>
        <Btn onClick={handleClose}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveParticipantPmt",{...f,loanid:f.loanid||loanid,participantscheduledpmtid:f.participantscheduledpmtid||participantscheduledpmtid},initial?"Edited":"Added","ParticipantPmts",(initial?"Updated":"Added")+" participant payment",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
